import studentEarlyAlertsService from "../../apiServices/student/studentEarlyAlertsService";
import { setStudentEarlyAlerts } from "../../store/slices/student/studentEarlyAlertsSlice";


export function getStudentEarlyAlertsDetails(id: string, count: number) {
  return async function (dispatch: any, getState: any) {
    let response = await studentEarlyAlertsService.getEarlyAlerts(id, count)
    if (response?.success === true) {
      dispatch(setStudentEarlyAlerts(response.data));
    } else {
      console.log("error");
    }
  };
}